import { useSession } from '../index';
/**
 * Custom hook to determine if the current user authenticated via Untis SSO
 * @returns boolean indicating if the user is an Untis SSO user
 */
export const useIsUntisUser = () => {
    const { user } = useSession();
    return user?.ssoSource === 'untis';
};
